import React from 'react'
import { Link } from 'react-router-dom'

export const ExitClub: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-blue-700 to-slate-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-4">
            Join the <span className="text-blue-200">Professional Exit Club</span>
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Become part of an exclusive community of timeshare owners who successfully exited 
            their contracts and now help others achieve the same freedom.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Benefits */}
          <div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 border border-white/20">
              <h3 className="text-2xl font-bold text-blue-200 mb-6">
                🏆 Professional Exit Club Member Benefits:
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Priority Email Support
                    </h4>
                    <p className="text-blue-200 text-sm">
                      Get first-priority responses to your questions from our experienced team 
                      who has helped thousands exit successfully.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Private Facebook Community
                    </h4>
                    <p className="text-blue-200 text-sm">
                      Connect with 4,847+ successful exit stories, share experiences, 
                      and get real-time advice from people who've been through it.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Monthly Live Q&A Sessions
                    </h4>
                    <p className="text-blue-200 text-sm">
                      Join live video calls with exit experts to ask questions about your 
                      specific situation and get personalized guidance.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Document Review Service
                    </h4>
                    <p className="text-blue-200 text-sm">
                      Have your exit letters and legal documents reviewed by our team 
                      before sending to ensure maximum effectiveness.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-200 text-blue-800 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">
                      Success Celebration Rewards
                    </h4>
                    <p className="text-blue-200 text-sm">
                      When you successfully exit, receive exclusive Exit Club merchandise 
                      and a personal congratulations from our founder.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Join CTA */}
          <div>
            <div className="bg-gradient-to-br from-slate-100 to-slate-200 text-slate-800 rounded-lg p-8">
              <div className="text-center mb-6">
                <div className="text-sm font-semibold mb-2">EXCLUSIVE MEMBERSHIP</div>
                <div className="flex items-center justify-center mb-4">
                  <span className="text-5xl font-bold">FREE</span>
                </div>
                <div className="text-sm font-medium mb-4">
                  Included with DIY Guide Purchase
                </div>
                <div className="bg-slate-300 rounded-lg p-3 mb-6">
                  <div className="text-sm font-semibold">Lifetime Access Value:</div>
                  <div className="text-xs">Monthly live sessions ($97/month value)</div>
                  <div className="text-xs">Private community access ($47/month value)</div>
                  <div className="text-xs">Priority support ($197/month value)</div>
                  <div className="text-xs font-bold border-t border-slate-400 pt-2 mt-2">Total Value: $341/month</div>
                </div>
              </div>
              
              <Link 
                to="/register"
                className="w-full bg-blue-700 text-white font-bold py-4 px-6 rounded-lg text-lg mb-4 hover:bg-blue-800 transition-colors block text-center no-underline"
              >
                Join Professional Exit Club + Get DIY Guide - $997
              </Link>
              
              <div className="bg-slate-400 rounded-lg p-4 mb-4">
                <div className="text-center text-slate-800 text-sm">
                  <div className="font-semibold mb-1">Join 4,847+ Success Stories</div>
                  <div className="text-xs">Average savings vs attorneys: $11,347</div>
                  <div className="text-xs">Average exit time: 4.2 months</div>
                </div>
              </div>
              
              <div className="text-center text-slate-700 text-sm space-y-1">
                <div className="flex items-center justify-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Instant Exit Club Access
                </div>
                <div className="flex items-center justify-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Complete DIY Guide Included
                </div>
                <div className="flex items-center justify-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  60-Day Money-Back Guarantee
                </div>
              </div>
            </div>
            
            {/* Success Stories Highlight */}
            <div className="bg-blue-700 rounded-lg p-6 mt-6">
              <h4 className="font-bold text-white text-center mb-4">
                💬 What Professional Exit Club Members Say
              </h4>
              <div className="space-y-3">
                <div className="bg-white/10 rounded-lg p-3">
                  <p className="text-white text-sm mb-2">
                    "The community support was incredible. Having people who actually went through 
                    this process made all the difference."
                  </p>
                  <p className="text-blue-200 text-xs">- Jennifer K., Exited Wyndham in 3 months</p>
                </div>
                <div className="bg-white/10 rounded-lg p-3">
                  <p className="text-white text-sm mb-2">
                    "The live Q&A sessions saved me from making costly mistakes. Worth every penny."
                  </p>
                  <p className="text-blue-200 text-xs">- Michael R., Saved $14,000 vs attorney quote</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <h3 className="text-xl font-bold text-white mb-4">
              Ready to Break Free from Your Timeshare?
            </h3>
            <p className="text-blue-200 mb-6">
              Join thousands of successful Professional Exit Club members and get your freedom back today.
            </p>
            <Link 
              to="/register"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors no-underline"
            >
              Join the Professional Exit Club Now - $997
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
